import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

const SectionTitle = ({ title, className = "" }) => {
  return (
    <>
      <PC>
        <div className={`section-title ${className}`}>
          <h2>{title}</h2>
        </div>
      </PC>

      <Notebook>
        <div className={`section-title ${className}`}>
          <h2>{title}</h2>
        </div>
      </Notebook>

      <Tablet>
        <div className={`section-title ${className}`}>
          <h2 style={{ fontSize: "1.8rem" }}>{title}</h2>
        </div>
      </Tablet>

      <Mobile>
        <div className={`section-title ${className}`} style={{ margin: "30px 0 15px" }}>
          <h2 style={{ fontSize: "1.5rem" }}>{title}</h2>
        </div>
      </Mobile>
    </>
  )
}

export default SectionTitle
